import Vue from 'vue'
import Router from 'vue-router'
import fa from "element-ui/src/locale/lang/fa";

const Home = resolve => require(['@/views/home'], resolve)
const Login = resolve => require(['@/views/login'], resolve)
const ForgetPassword = resolve => require(['@/views/login/forgetPassword'], resolve)
const ResetPassword = resolve => require(['@/views/login/resetPassword'], resolve)

const Layout = resolve => require(['@/layout'], resolve)
const SystemUser = resolve => require(['@/views/system/user'], resolve)
const membersDepartments = resolve => require(['@/views/system/user/membersDepartments'], resolve)

const SystemAddUser = resolve => require(['@/views/system/user/addUser.vue'], resolve)
const SystemEditUser = resolve => require(['@/views/system/user/editUser.vue'], resolve)
const SystemRole = resolve => require(['@/views/system/role'], resolve)
const SystemAddRole = resolve => require(['@/views/system/role/addRole.vue'], resolve)
const SystemEditRole = resolve => require(['@/views/system/role/editRole.vue'], resolve)
const SystemOrg = resolve => require(['@/views/system/org'], resolve)
const SystemAuthTree = resolve => require(['@/views/system/authTree'], resolve)
const ResumePublic = resolve => require(['@/views/resume/public'], resolve)
const ResumePrivate = resolve => require(['@/views/resume/private'], resolve) 
const ResumeDetail = resolve => require(['@/views/resume/detail/index1'], resolve)
const APPResumeDetail = resolve => require(['@/views/resume/detail/APPindex.vue'], resolve)
const recruitmentAuditRecruitmentFollowUp = resolve => require(['@/views/recruitmentAudit/recruitmentFollowUp'], resolve)
const recruitmentAuditRecruitmentAudit = resolve => require(['@/views/recruitmentAudit/recruitmentAudit'], resolve)
const dataCheck = resolve => require(['@/views/recruitmentAudit/datacheck'], resolve)
const projectPlaza = resolve => require(['@/views/listOfItems/projectPlaza'], resolve)
const projectPlazaDetail = resolve => require(['@/views/listOfItems/projectPlazaDetail'], resolve)
const listOfItemsListOfItems = resolve => require(['@/views/listOfItems/listOfItems'], resolve)
const listOfItemsclientList = resolve => require(['@/views/listOfItems/clientList'], resolve)
const listOfItemsaddClient = resolve => require(['@/views/listOfItems/addClient'], resolve)
const listOfItemsCooperative = resolve => require(['@/views/listOfItems/listOfItemsCooperative'], resolve)
const listOfItemsUserProjectManage = resolve => require(['@/views/listOfItems/userProjectManage'], resolve)
const listOfItemsEditProject = resolve => require(['@/views/listOfItems/newProject'], resolve)
const listOfItemsNewProject = resolve => require(['@/views/listOfItems/newProject'], resolve)
const listOfItemsProjectDetails = resolve => require(['@/views/listOfItems/projectDetails'], resolve)
const listOfItemsProjectMap = resolve => require(['@/views/listOfItems/projectMap'], resolve)
const checkAdmin = resolve => require(['@/views/listOfItems/checkAdmin/checkAdmin'], resolve)

const NewAddCheck = resolve => require(['@/views/listOfItems/checkAdmin/newAddCheck'],resolve)
const CheckEdit = resolve => require(['@/views/listOfItems/checkAdmin/checkEdit'],resolve)
const listOfItemsprojectMapRoutePlan = resolve => require(['@/views/listOfItems/projectMapRoutePlan'], resolve)
const listOfItemsCopyAddProject = resolve => require(['@/views/listOfItems/newProject'], resolve)
const ResumeSingleImport = resolve => require(['@/views/resume/cv/index'], resolve)
const ResumeEdit = resolve => require(['@/views/resume/cv'], resolve)
const FormExample = resolve => require(['@/components/formExample'], resolve)
const DailyData = resolve => require(['@/views/workBench/dailyData'], resolve)
const chat = resolve => require(['@/views/chat'], resolve);
const receiveResume = resolve => require(['@/views/chat/receiveResume'], resolve);
const Sale = resolve => require(['@/views/workBench/sale/sale'], resolve)
const Checklist = resolve => require(['@/views/workBench/sale/checklist'], resolve)
const Detailed = resolve => require(['@/views/workBench/sale/detailed'], resolve)
const TeamData = resolve => require(['@/views/dataStats/teamData'], resolve)
const dataStats = resolve => require(['@/views/workBench/dataStats'], resolve)
const pieChart = resolve => require(['@/views/dataStats/pieChart'], resolve)
const dataMonitor = resolve => require(['@/views/dataStats/dataMonitor'], resolve)
const BatchImport = resolve => require(['@/views/resume/batchImport'], resolve)
const recordList = resolve => require(['@/views/resume/public/recordList'], resolve)
const BatchImportDetial = resolve => require(['@/views/resume/batchImport/detial'], resolve)
const Commission = resolve => require(['@/views/system/commission'], resolve)
const Strategy = resolve => require(['@/views/system/commission/strategy'], resolve);
const CommissionProject = resolve => require(['@/views/system/commission/project'], resolve)
const MailConfig = resolve => require(['@/views/system/mailConfig'], resolve)
const systemDetail = resolve => require(['@/views/system/detail'], resolve)
const CompanyEmail = resolve => require(['@/views/system/companyEmail'], resolve)
const Setup = resolve => require(['@/views/system/setup'], resolve)
const ResumeHandler = resolve => require(['@/views/resume/resumeHandler/resumeHandler'], resolve)
const ResumeHandlerInfo = resolve => require(['@/views/resume/resumeHandler/resumeInfo'], resolve)
const Companystore = resolve => require(['@/views/library/company/companyStore'], resolve)
const Team = resolve => require(['@/views/resume/team'], resolve) 
const Teamhandle = resolve => require(['@/views/resume/teamhandle/teamhandle'], resolve)
const ReportForm = resolve => require(['@/views/dataStats/reportform'],resolve)
const Industry = resolve => require(['@/views/IndustryPosition/industry'],resolve)
const Position = resolve => require(['@/views/IndustryPosition/position'],resolve)
const ReportformRecruit = resolve => require(['@/views/reportform/reportformRecruit'],resolve)
// APPSTORE
const positionAdmin = resolve => require(['@/views/appstore/positionAdmin'],resolve)
const uplistName = resolve => require(['@/views/appstore/uplistName'],resolve)
const uprangeSetup = resolve => require(['@/views/appstore/uprangeSetup'],resolve)
const appresumeStore = resolve => require(['@/views/appstore/appresumeStore'],resolve)
const appfollowUp = resolve => require(['@/views/appstore/appfollowUp'],resolve)
const appfeedBack = resolve => require(['@/views/appstore/appfeedBack'],resolve)
const nuclearManagement = resolve => require(['@/views/financialManagement/nuclearManagement'],resolve)
const makeDetails = resolve => require(['@/views/financialManagement/makeDetails'],resolve)
const financialDetail = resolve => require(['@/views/financialManagement/Detail'],resolve)
const share = resolve => require(['@/views/listOfitems/share'],resolve)
// agreements
const privacyPolicy =  resolve=> require(['@/views/agreements/privacyPolicy'],resolve)
const agreementsUser =  resolve=> require(['@/views/agreements/user'],resolve)

const wallet = resolve => require(['@/views/fundsManagement/wallet'],resolve)
const paymentBill = resolve => require(['@/views/fundsManagement/paymentBill'],resolve)
const collectionStatement = resolve => require(['@/views/fundsManagement/collectionStatement'],resolve)
const pdfPage = resolve => require(['@/views/chat/pdfPage'],resolve)
Vue.use(Router)
export default new Router({
        routes: [{
                path: '/',
                component: Login,
                redirect: '/user',
                name: '登录',
                meta: { keepAlive: false, title: '登录' }
            },
            {
                path: '/forgetpassword',
                component: ForgetPassword,
                name: '忘记密码',
                meta: { keepAlive: false, title: '找回密码' }
            },
            {
                path: '/resetpassword',
                component: ResetPassword,
                name: '重置密码',
                meta: { keepAlive: false, title: '重置密码' }
            },
            {
                path: '/pdfPage',
                component: pdfPage,
                name: '附件简历',
                meta: { keepAlive: false, title: '附件简历' }
            },
            {
                path: '/blankDetail',
                component: ResumeDetail,
                name: '简历详情',
                meta: { keepAlive: false, title: '简历详情' },
            },
            // {
            //     path: '/share',
            //     component: share,
            //     name: '分享',
            //     meta: { keepAlive: false, title: '分享' },
            // },
            {
                path: '/APPblankDetail',
                component: APPResumeDetail,
                name: 'App简历详情',
                meta: { keepAlive: false, title: 'APP简历详情' },
            },
            {
                path: '/formExample',
                component: FormExample,
                name: '表单校验',
                meta: { keepAlive: false, title: '表单校验' },
            },
            {
                path: '/projectDetails',
                component: listOfItemsProjectDetails,
                name: '项目详情',
                meta: { keepAlive: false, title: '项目详情' },
            },
             {
                path: '/privacyPolicy',
                component: privacyPolicy,
                name: '上啥班云平台用户隐私协议',
                meta: { keepAlive: false, title: '上啥班云平台用户隐私协议' },
            },
               {
                path: '/agreementsUser',
                component: agreementsUser,
                name: '上啥班云管家用户服务协议',
                meta: { keepAlive: false, title: '上啥班云管家用户服务协议' },
            },
            
            {
                path: '/manage',
                redirect: '/home',
                component: Layout,
                name: '',
                children: [{
                        path: '/home',
                        component: Home,
                        name: '首页',
                        meta: { keepAlive: false, title: '首页', affix: true }
                    },
                    {
                        path: '/system/user',
                        component: SystemUser,
                        name: '用户管理',
                        meta: { keepAlive: true, title: '用户管理' },
                    },
                    {
                        path: '/system/user/membersDepartments',
                        component: membersDepartments,
                        name: '成员与部门',
                        meta: { keepAlive: true, title: '成员与部门' },
                    },
                    {
                        path: '/system/editUser',
                        component: SystemEditUser,
                        name: '编辑用户',
                        meta: { keepAlive: false, title: '编辑用户' },
                    },
                    {
                        path: '/system/addUser',
                        component: SystemAddUser,
                        name: '新建用户',
                        meta: { keepAlive: false, title: '新建用户' },
                    },
                    {
                        path: '/system/role',
                        component: SystemRole,
                        name: '角色管理',
                        meta: { keepAlive: false, title: '角色管理' },
                    },
                    {
                        path: '/system/editRole',
                        component: SystemEditRole,
                        name: '编辑角色',
                        meta: { keepAlive: false, title: '编辑角色' },
                    },
                    {
                        path: '/system/addRole',
                        component: SystemAddRole,
                        name: '新建角色',
                        meta: { keepAlive: false, title: '新建角色' },
                    },
                    {
                        path: '/system/org',
                        component: SystemOrg,
                        name: '组织架构',
                        meta: { keepAlive: false, title: '组织架构' },
                    },
                    {
                        path: '/system/authTree',
                        component: SystemAuthTree,
                        name: '权限树管理',
                        meta: { keepAlive: false, title: '权限树管理' },
                    },
                    {
                        path: '/system/mailConfig',
                        component: MailConfig,
                        name: '简历邮箱配置',
                        meta: { keepAlive: false, title: '简历邮箱配置' },
                    },
                    {
                        path: '/system/companyEmail',
                        component: CompanyEmail,
                        name: '公司邮箱配置',
                        meta: { keepAlive: false, title: '公司邮箱配置' },
                    },
                    {
                        path: '/system/detail',
                        component: systemDetail,
                        name: '识别统计详情',
                        meta: { keepAlive: false, title: '识别统计详情' },
                    },
                    
                    {
                        path: '/system/setup',
                        component: Setup,
                        name: '参数设置',
                        meta: { keepAlive: false, title: '参数设置' },
                    },
                    {
                        path: '/system/commission',
                        component: Commission,
                        name: '提成管理',
                        meta: { keepAlive: false, title: '提成管理' },
                    },
                    {
                        path: '/system/strategy',
                        component: Strategy,
                        name: '提成策略',
                        meta: { keepAlive: false, title: '提成策略' },
                    },
                    {
                        path: '/system/commissionproject',
                        component: CommissionProject,
                        name: '项目提成',
                        meta: { keepAlive: false, title: '提成项目' },
                    },
                    {
                        path: '/system/resumeHandle',
                        component: ResumeHandler,
                        name: '问题简历处理',
                        meta: { keepAlive: false, title: '问题简历处理' },
                    },
                    {
                        path: '/system/resumeHandleInfo',
                        component: ResumeHandlerInfo,
                        name: '问题简历详情',
                        meta: { keepAlive: false, title: '问题简历详情' },
                    },
                    {
                        path: '/resume/public',
                        component: ResumePublic,
                        name: '简历公海',
                        meta: { keepAlive: true, title: '简历公海' },
                    },
                    {
                        path: '/resume/private',
                        component: ResumePrivate,
                        name: '简历私有库',
                        meta: { keepAlive: true, title: '简历私有库' },
                    },
                    {
                        path: '/resume/detail',
                        component: ResumeDetail,
                        name: '简历详情',
                        meta: { keepAlive: false, title: '简历详情' },
                    },
                    {
                        path: '/resume/appdetail',
                        component: APPResumeDetail,
                        name: 'App简历详情',
                        meta: { keepAlive: false, title: 'APP简历详情' },
                    },
                    {
                        path: '/recruitmentAudit/recruitmentFollowUp',
                        component: recruitmentAuditRecruitmentFollowUp,
                        name: '招聘跟进',
                        meta: {
                            keepAlive: true,
                            title: '招聘跟进',
                            eName: 'recruitmentFollowUp'
                        },
                    },
                    {
                        path: '/recruitmentAudit/recruitmentAudit', 
                        component: recruitmentAuditRecruitmentAudit,
                        name: '审核',
                        meta: {
                            keepAlive: true,
                            title: '审核',
                            eName: 'recruitmentAudit'
                        },
                    },
                    {
                        path: '/recruitmentAudit/datacheck', 
                        component: dataCheck,
                        name: '数据校对',
                        meta: {
                            keepAlive: true,
                            title: '数据校对',
                            eName: 'datacheck'
                        },
                    },
                    {
                        path: '/listOfItems/projectPlaza',
                        component: projectPlaza,
                        name: '项目广场',
                        meta: {
                            keepAlive: true,
                            title: '项目广场',
                            eName: 'projectPlaza'
                        },
                    }, {
                        path: '/listOfItems/projectPlazaDetail',
                        component: projectPlazaDetail,
                        name: '项目详情',
                        meta: {
                            keepAlive: true,
                            title: '项目详情',
                            eName: 'projectPlazaDetail'
                        },
                    },
                    {
                        path: '/listOfItems/listOfItems',
                        component: listOfItemsListOfItems,
                        name: '项目管理',
                        meta: {
                            keepAlive: true,
                            title: '项目管理',
                            eName: 'listOfItems'
                        },
                    },
                    {
                        path: '/listOfItems/userProjectManage',
                        component: listOfItemsUserProjectManage,
                        name: '成员项目管理',
                        meta: {
                            keepAlive: true,
                            title: '成员项目管理',
                            eName: 'userProjectManage'
                        },
                    },
                    {
                        path: '/listOfItems/newProject',
                        component: listOfItemsNewProject,
                        name: '新增项目',
                        meta: {
                            keepAlive: true,
                            title: '新增项目',
                            eName: 'newProject'
                        },
                    },
                    {
                        path: '/listOfItems/editProject',
                        component: listOfItemsEditProject,
                        name: '编辑项目',
                        meta: { keepAlive: true, title: '编辑项目' ,eName: "newProject"},
                    },
                    {
                        path: '/listOfItems/copyAddProject',
                        component: listOfItemsCopyAddProject,
                        name: '复制新建项目',
                        meta: { keepAlive: true, title: '复制新建项目' },
                    },
                    {
                        path: '/listOfItems/projectDetails',
                        component: listOfItemsProjectDetails,
                        name: '项目详情',
                        meta: { keepAlive: false, title: '项目详情' },
                    },
                    {
                        path: '/listOfItems/projectMap',
                        component: listOfItemsProjectMap,
                        name: '项目地图',
                        meta: {
                            keepAlive: true,
                            title: '项目地图',
                            eName: 'projectMap'
                        },
                    },
                    {
                        path: '/listOfItems/checkAdmin/checkAdmin',
                        component: checkAdmin,
                        name: '核对管理',
                        meta: {
                            keepAlive: true,
                            title: '核对管理',
                            eName: 'checkAdmin'
                        },
                    },
                    {
                        path: '/listOfItems/clientList',
                        component: listOfItemsclientList,
                        name: '客户管理',
                        meta: {
                            keepAlive: true,
                            title: '客户管理',
                            eName: 'clientList'
                        },
                    },
                    {
                        path: '/listOfItems/cooperative',
                        component: listOfItemsCooperative,
                        name: '客户详情',
                        meta: {
                            keepAlive: true,
                            title: '客户详情',
                            eName: 'cooperative'
                        },
                    },
                    {
                        path: '/listOfItems/addClient',
                        component: listOfItemsaddClient,
                        name: '客户新建',
                        meta: {
                            keepAlive: true,
                            title: '客户新建',
                            eName: "addClient"
                        },
                    },
                    // {
                    //     path: '/listOfItems/lookCheck',
                    //     component: share,
                    //     name: '查看核对单',
                    //     meta: {
                    //         keepAlive: true,
                    //         title: '查看核对单',
                    //         eName: "share"
                    //     },
                    // },
                    {
                        path: '/listOfItems/projectMapRoutePlan',
                        component: listOfItemsprojectMapRoutePlan,
                        name: '线路规划',
                        meta: {
                            keepAlive: false,
                            title: '线路规划',
                            eName: 'projectMapRoutePlan'
                        },
                    },
                    {
                        path: '/resume/edit',
                        component: ResumeEdit,
                        name: '简历编辑',
                        meta: { keepAlive: false, title: '简历编辑' },
                    },
                    {
                        path: '/resume/singleImport',
                        component: ResumeSingleImport,
                        name: '简历录入',
                        meta: { keepAlive: false, title: '简历录入' },
                    },
                    {
                        path: '/resume/batchImport',
                        component: BatchImport,
                        name: '简历录入',
                        meta: { keepAlive: true, eName: 'batchImport', title: '简历录入' },
                    },
                    {
                        path: '/resume/recordList',
                        component: recordList,
                        name: '上传记录',
                        meta: { keepAlive: true, eName: 'recordList', title: '上传记录' },
                    },
                    {
                        path: '/resume/batchImportDetial',
                        component: BatchImportDetial,
                        name: '批量导入详情',
                        meta: { keepAlive: true, eName: 'BatchImportDetial', title: '批量导入详情' },
                    },
                    // 工作台
                    {
                        path: '/chat/page',
                        component: chat,
                        name: '在线沟通',
                        meta: { keepAlive: false, title: '在线沟通' }
                    },
                    {
                        path: '/chat/receiveResume',
                        component: receiveResume,
                        name: '简历投递',
                        meta: { keepAlive: false, title: '简历投递' }
                    },
                    {
                        path: '/workBench/dailyData',
                        component: DailyData,
                        name: '日常数据',
                        meta: { keepAlive: false, title: '日常数据' }
                    },
                    {
                        path: '/workBench/sale/sale', 
                        component: Sale,
                        name: 'PM工作台',
                        meta: { keepAlive: false, title: 'PM工作台' }
                    },
                    {
                        path: '/workBench/sale/checklist', 
                        component: Checklist,
                        name: '核对单',
                        meta: { keepAlive: true, eName:'checklist', title:'核对单' }
                    },
                    {
                        path: '/workBench/sale/detailed', 
                        component: Detailed,
                        name: '查看明细',
                        meta: { keepAlive: true, title: '查看明细' }
                    },
                    {
                        path: '/workBench/dataStats',
                        component: dataStats,
                        name: '数据看板',
                        meta: { keepAlive: false, title: '数据看板' }
                    },
                    // 团队数据
                    {
                        path: '/dataStats/teamData',
                        component: TeamData,
                        name: '团队数据',
                        meta: { keepAlive: false, title: '团队数据' }
                    },
                    {
                        path: '/dataStats/pieChart', 
                        component: pieChart,
                        name: '服务数据',
                        meta: { keepAlive: false, title: '图表' }
                    },
                    {
                        path: '/dataStats/dataMonitor', 
                        component: dataMonitor,
                        name: '数据监控',
                        meta: { keepAlive: false, title: '数据监控' }
                    },
                    {
                        path: '/library/company/Companystore',
                        component: Companystore,
                        name: '公司邮件简历库',
                        meta: { keepAlive: false, title: '公司邮件简历库' }
                    },
                    {
                        path: '/resume/team',
                        component: Team,
                        name: '简历团队库',
                        meta: { keepAlive: false, title: '简历团队库' }
                    },
                    {
                        path: '/resume/teamhandle/teamhandle',
                        component: Teamhandle,
                        name: '团队邮件简历库',
                        meta: { keepAlive: false, title: '团队邮件简历库' }
                    },
                    {
                        path: '/dataStats/reportform',
                        component: ReportForm,
                        name: '提成报表',
                        meta: {keepAlive: false, title: '提成报表'}
                    },
                    {
                        path: '/IndustryPosition/industry',
                        component: Industry,
                        name: '行业管理',
                        meta: {keepAlive: false, title: '行业管理'}
                    },
                    {
                        path: '/IndustryPosition/position',
                        component: Position,
                        name: '岗位管理',
                        meta: {keepAlive: false, title: '岗位管理'}
                    },
                    // { 
                    //     path: '/appstore/positionAdmin',
                    //     component: positionAdmin,
                    //     name: '职位关系管理',
                    //     meta: {keepAlive: false, title: '职位关系管理'}
                    // },
                    {
                        path: '/appstore/uplistName',
                        component: uplistName,
                        name: '资源库开放名单',
                        meta: {keepAlive: false, title: '资源库开放名单'}
                    },
                    {
                        path: '/appstore/uprangeSetup',
                        component: uprangeSetup,
                        name: '开放范围设置',
                        meta: {keepAlive: false, title: '开放范围设置'}
                    },
                    {
                        path: '/appstore/appresumeStore',
                        component: appresumeStore,
                        name: '简历公海',
                        meta: {keepAlive: false, title: '简历公海'}
                    },
                    {
                        path: '/appstore/appfollowUp',
                        component: appfollowUp,
                        name: '跟进结果',
                        meta: {keepAlive: false, title: '跟进结果'}
                    },
                    {
                        path: '/appstore/appfeedBack',
                        component: appfeedBack,
                        name: '服务反馈',
                        meta: {keepAlive: false, title: '服务反馈'}
                    },
                    {
                        path: '/financialManagement/nuclearManagement',
                        component: nuclearManagement,
                        name: '提成单管理',
                        meta: {keepAlive: false, title: '提成单管理'}
                    },
                    {
                        path: '/financialManagement/makeDetails',
                        component: makeDetails,
                        name: '提成详情',
                        meta: {keepAlive: false, title: '提成详情'}
                    },
                    {
                        path: '/financialManagement/Detail',
                        component: financialDetail,
                        name: '明细',
                        meta: {keepAlive: false, title: '明细'}
                    },
                    {
                        path: '/reportform/reportformRecruit',
                        component: ReportformRecruit,
                        name: '项目招聘报表',
                        meta: {keepAlive: true, eName: 'reportformRecruit', title: '项目招聘报表'}

                    },
                    {
                        path: '/listOfItems/checkAdmin/newAddCheck',
                        component: NewAddCheck,
                        name: '新建核对单',
                        meta: {keepAlive: true, eName: 'newAddCheck', title: '新建核对单'}
                    },
                    {
                        path: '/listOfItems/checkAdmin/checkEdit',
                        component: CheckEdit,
                        name: '编辑核对单',
                        meta: {keepAlive: true, eName: 'CheckEdit', title: '新建核对单'}
                    },
                
                    {
                        path: '/fundsManagement/wallet',
                        component: wallet,
                        name: '钱包',
                        meta: {keepAlive: false, eName: 'wallet', title: '钱包'}
                    },
                    {
                        path: '/fundsManagement/paymentBill',
                        component: paymentBill,
                        name: '付款账单',
                        meta: {keepAlive: false, eName: 'paymentBill', title: '付款账单'}
                    },
                    {
                        path: '/fundsManagement/collectionStatement',
                        component: collectionStatement,
                        name: '收款账单',
                        meta: {keepAlive: false, eName: 'collectionStatement', title: '收款账单'}
                    },
                ]
            },
            {
                path: '/user',
                name: Login,
                component: Login,
                meta: { keepAlive: false, title: '登录' }
            },

        ]
    })
    // 点击当前路由时会报错，不影响功能但是难看
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/routers.js